import React, { useEffect, useState } from 'react';
import { TriangleAlertIcon } from 'lucide-react';
import { Button } from '../sf/Button';
import { Modal } from '../sf/Modal';
import { NewBadge } from '../sf/NewBadge';
import { ScopedNotification } from '../sf/ScopedNotification';
interface UnlockPeriodModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}
export function UnlockPeriodModal({
  open,
  onClose,
  onConfirm
}: UnlockPeriodModalProps) {
  const [reason, setReason] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const missing = !reason.trim();
  useEffect(() => {
    if (!open) return;
    setReason('');
    setSubmitted(false);
  }, [open]);
  function handleConfirm() {
    setSubmitted(true);
    if (missing) return;
    onConfirm(reason.trim());
  }
  return <Modal open={open} onClose={onClose} title="Unlock October 2026" description="Admin only. Reopens the period for every employee." footer={<>
          <Button onClick={onClose} data-id="element-774" data-mp="3jbvl5an4hyq8">Cancel</Button>
          <Button variant="brand" onClick={handleConfirm} data-id="element-775" data-mp="3j8zp5ruu5k4f">
            Unlock Period
          </Button>
        </>} data-id="element-773" data-mp="vhav5yohunbm">
      <div className="space-y-4" data-id="element-776" data-mp="3saz7qoli0w9h">
        <p className="flex flex-wrap items-center gap-2 text-xs text-sf-weak" data-id="element-777" data-mp="3saphr10gep3s">
          <NewBadge data-id="element-778" data-mp="xv3nmewefst" />
          Period unlocking is a proposed rebuild feature — main has no period lock today.
        </p>
        <ScopedNotification tone="warning" icon={TriangleAlertIcon} data-id="element-779" data-mp="5vef6ek7oeh2">
          Lines become editable again and statements lose their final status until the period is re-locked.
        </ScopedNotification>
        <div data-id="element-780" data-mp="fuvkguvjwqci">
          <label htmlFor="unlock-reason" className="mb-1 block text-xs font-semibold" data-id="element-781" data-mp="frzkl1057rlf">
            <abbr title="required" className="mr-0.5 text-sf-red no-underline" data-id="element-782" data-mp="juw8964jidw8">*</abbr>Reason
          </label>
          <textarea id="unlock-reason" rows={3} value={reason} onChange={event => setReason(event.target.value)} placeholder="Saved to the period’s audit trail" aria-invalid={submitted && missing} className={`w-full rounded border bg-white px-3 py-2 text-[13px] focus:outline-none focus:ring-1 ${submitted && missing ? 'border-sf-red focus:ring-sf-red' : 'border-sf-border-strong focus:border-sf-blue focus:ring-sf-blue'}`} data-id="element-783" data-mp="2hnjubn2pac19" />
          {submitted && missing && <p className="mt-1 text-xs text-sf-red" data-id="element-784" data-mp="bpv6yrfyvbm0">A reason is required to unlock.</p>}
        </div>
      </div>
    </Modal>;
}